import React from 'react'
import PortableText from "react-portable-text"
import { SanityImage } from "sanity-image"

const Portable = (props) => {

    const {blocks} = props;

    const b = blocks.map((block) => {
      return {...block, markDefs: []}
    })

    return (
      <PortableText
      // Pass in block content straight from Sanity.io
      content={b}
      // Optionally override marks, decorators, blocks, etc. in a flat
      // structure without doing any gymnastics
      serializers={{
        li: ({ children }) => <li className="special-list-item">{children}</li>,
      }}
    />
    )
}

export default Portable
